import { render, staticRenderFns } from "./listTabel.vue?vue&type=template&id=53de5cd3&scoped=true"
import script from "./listTabel.vue?vue&type=script&lang=js"
export * from "./listTabel.vue?vue&type=script&lang=js"
import style0 from "./listTabel.vue?vue&type=style&index=0&id=53de5cd3&prod&lang=scss&scoped=true"
import style1 from "./listTabel.vue?vue&type=style&index=1&id=53de5cd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de5cd3",
  null
  
)

export default component.exports